// import React from 'react'
// TODO: Temporarily hidden - Pay Later disabled during Best Of sale
// Restore when Pay Later is re-enabled after Best Of campaign ends
// Contact: Sean Novis (Payments team)
// Slack context: https://luxgroup-hq.slack.com/archives/C06PT0KPZ5L/p1767656827122429?thread_ts=1766063198.377459&cid=C06PT0KPZ5L
// import LineClockDollarIcon from 'LuxKit/Icons/line/LineClockDollarIcon'
// import Pill from 'LuxKit/Pill'

function PayLaterPill() {
  // TODO: Restore Pay Later pills when re-enabled after Best Of campaign
  return null
  // return (
  //   <Pill startIcon={<LineClockDollarIcon />}>
  //     Pay later
  //   </Pill>
  // )
}

export default PayLaterPill
